import { useEffect, useRef } from 'react';

import { Col, Form, Row, Button, Modal, Alert } from 'react-bootstrap';
import { AiFillCloseCircle } from 'react-icons/ai';

import styles from './Trienio.module.css';
import BriefingThumb from '../BriefingThumb';

const Trienio = props => {
  const trienioArquivo1Ref = useRef();
  const trienioArquivo2Ref = useRef();
  const trienioArquivo3Ref = useRef();
  const trienioArquivo4Ref = useRef();
  const trienioArquivo5Ref = useRef();

  useEffect(() => {
    (props.trienioArquivo1 ||
      props.trienioArquivo2 ||
      props.trienioArquivo3 ||
      props.trienioArquivo4 ||
      props.trienioArquivo5) &&
      window.scrollBy(0, 350);
  }, [props.trienioArquivo1, props.trienioArquivo2, props.trienioArquivo3, props.trienioArquivo4, props.trienioArquivo5]);

  return (
    <>
      <Row>
        <h2 className={styles.title}>Triênio</h2>
      </Row>

      <Alert variant="warning" className="mt-4">
        <Alert.Heading className={styles.alert_heading}>Importante!</Alert.Heading>

        <div className={styles.alert_container}>
          <h3 className={styles.alert_title}>
            Pagamento do Adicional por Tempo de Serviço (Triênio)
          </h3>

          <p>
            Na FeSaúde, o benefício equivalente ao “triênio” é chamado de Evolução por Aprimoramento e Antiguidade. Ele consiste em um acréscimo de 3% sobre o salário básico inicial do cargo, concedido a cada 3 anos de tempo de serviço, respeitando os critérios previstos na regulamentação. 
          </p>

          <p className={styles.alert_strong}>
            ✅ Requisitos para recebimento:
          </p>

          <p>
            Para ter direito ao benefício, o(a) empregado(a) deve cumulativamente: 
          </p>

          <ul>
            <li>
              Ter <span className={styles.alert_strong}>três anos de tempo de serviço</span> na FeSaúde, com <span className={styles.alert_strong}>exercício efetivo mínimo de dois terços do período</span>;
            </li>
            <li>
              Apresentar <span className={styles.alert_strong}>comprovantes de qualificação profissional</span> relacionados à sua área de atuação, com carga horária mínima de: 

              <ul>
                <li>
                  <span className={styles.alert_strong}>90 horas</span> – Nível Fundamental
                </li>
                <li>
                  <span className={styles.alert_strong}>120 horas</span> – Nível Médio
                </li>
                <li>
                  <span className={styles.alert_strong}>180 horas</span> – Nível Superior
                </li>
              </ul>
            </li>
          </ul>

          <p>
            São aceitos <span className={styles.alert_strong}>cursos de extensão, congressos, graduação, qualificação, aperfeiçoamento e pós-graduação</span>, desde que <span className={styles.alert_strong}>realizados após a admissão e relacionados à sua área de atuação</span>. 
          </p>

          <p>
            ⚠️ Os comprovantes de qualificação devem ser, preferencialmente, reunidos em <span className={styles.alert_strong}>um único arquivo em formato PDF</span> para envio. 
          </p>

          <p className={styles.alert_strong}>
            ⏰ Prazos e retroatividade 
          </p>

          <p>
            Documentos enviados <span className={styles.alert_strong}>fora do prazo</span> somente poderão ser reapresentados mediante <span className={styles.alert_strong}>novo comunicado</span>. 
          </p>

          <ul>
            <li>
              Terão direito ao pagamento retroativo os empregados que completarem 3 anos de tempo de serviço na FeSaúde e apresentarem comprovantes de aprimoramento profissional. O cálculo será feito considerando a data de conclusão do aprimoramento. <br />
              
              <span className={styles.alert_strong}>Exemplo:</span> se o empregado completou o tempo de serviço em março de 2025, e o certificado apresentado é de maio de 2025, o pagamento começará em maio — mês em que os dois requisitos foram atendidos. 
            </li>
          </ul>

          <p className={styles.alert_strong}>
            📄 Regulamentação 
          </p>

          <p>
            As regras completas estão disponíveis na <span className={styles.alert_strong}>Deliberação do Conselho Curador FeSaúde nº 002/2023</span>, acessível no portal {' '}
            <span className={styles.alert_strong}>
              <a
                href="https://fesaudeportal.admrh.inf.br/rhsysweb/secure/XcpHome.xhtml"
                rel="noopener noreferrer"
                target="_blank"
              >
                ADMRH
              </a>
            </span>.
          </p>

          <p>
            Dúvidas podem ser encaminhadas para <span className={styles.alert_strong}>
              <a href="mailto:trienio@fesaude.niteroi.rj.gov.br">
                trienio@fesaude.niteroi.rj.gov.br
              </a>
            </span> 
          </p>
        </div>
      </Alert>

      <Row>
        <p className={styles.file_title}>
          Enviar anexo. (Máximo de 5 anexos com 5MB cada) <br />
          Arquivo suportado: .pdf
        </p>
      </Row>

      <Row>
        <Col sm={7}>
          <Form.Group controlId="trienioArquivo1" className="mt-4">
            <Form.Label>1º Anexo</Form.Label>
            <Form.Control
              type="file"
              className="border border-secondary"
              name="trienioArquivo1"
              onChange={e => props.handleTrienioArquivo(e, trienioArquivo1Ref)}
              ref={trienioArquivo1Ref}
            />
          </Form.Group>
        </Col>

        <Col sm={1}>
          {props.trienioArquivo1 &&
            <AiFillCloseCircle
              className={styles.file_reset_button}
              onClick={() => props.resetTrienioArquivo(trienioArquivo1Ref)}
              size={22}
            />
          }
        </Col>

        <BriefingThumb
          briefingArquivo={props.trienioArquivo1}
        />
      </Row>

      {(props.trienioArquivo1 || props.trienioArquivo2) &&
        <Row>
          <Col sm={7}>
            <Form.Group controlId="trienioArquivo2" className="mt-4">
              <Form.Label>2º Anexo</Form.Label>
              <Form.Control
                type="file"
                className="border border-secondary"
                name="trienioArquivo2"
                onChange={e => props.handleTrienioArquivo(e, trienioArquivo2Ref)}
                ref={trienioArquivo2Ref}
              />
            </Form.Group>
          </Col>

          <Col sm={1}>
            {props.trienioArquivo2 &&
              <AiFillCloseCircle
                className={styles.file_reset_button}
                onClick={() => props.resetTrienioArquivo(trienioArquivo2Ref)}
                size={22}
              />
            }
          </Col>

          <BriefingThumb
            briefingArquivo={props.trienioArquivo2}
          />
        </Row>
      }

      {(props.trienioArquivo2 || props.trienioArquivo3) &&
        <Row>
          <Col sm={7}>
            <Form.Group controlId="trienioArquivo3" className="mt-4">
              <Form.Label>3º Anexo</Form.Label>
              <Form.Control
                type="file"
                className="border border-secondary"
                name="trienioArquivo3"
                onChange={e => props.handleTrienioArquivo(e, trienioArquivo3Ref)}
                ref={trienioArquivo3Ref}
              />
            </Form.Group>
          </Col>

          <Col sm={1}>
            {props.trienioArquivo3 &&
              <AiFillCloseCircle
                className={styles.file_reset_button}
                onClick={() => props.resetTrienioArquivo(trienioArquivo3Ref)}
                size={22}
              />
            }
          </Col>

          <BriefingThumb
            briefingArquivo={props.trienioArquivo3}
          />
        </Row>
      }

      {(props.trienioArquivo3 || props.trienioArquivo4) &&
        <Row>
          <Col sm={7}>
            <Form.Group controlId="trienioArquivo4" className="mt-4">
              <Form.Label>4º Anexo</Form.Label>
              <Form.Control
                type="file"
                className="border border-secondary"
                name="trienioArquivo4"
                onChange={e => props.handleTrienioArquivo(e, trienioArquivo4Ref)}
                ref={trienioArquivo4Ref}
              />
            </Form.Group>
          </Col>

          <Col sm={1}>
            {props.trienioArquivo4 &&
              <AiFillCloseCircle
                className={styles.file_reset_button}
                onClick={() => props.resetTrienioArquivo(trienioArquivo4Ref)}
                size={22}
              />
            }
          </Col>

          <BriefingThumb
            briefingArquivo={props.trienioArquivo4}
          />
        </Row>
      }

      {(props.trienioArquivo4 || props.trienioArquivo5) &&
        <Row>
          <Col sm={7}>
            <Form.Group controlId="trienioArquivo5" className="mt-4">
              <Form.Label>5º Anexo</Form.Label>
              <Form.Control
                type="file"
                className="border border-secondary"
                name="trienioArquivo5"
                onChange={e => props.handleTrienioArquivo(e, trienioArquivo5Ref)}
                ref={trienioArquivo5Ref}
              />
            </Form.Group>
          </Col>

          <Col sm={1}>
            {props.trienioArquivo5 &&
              <AiFillCloseCircle
                className={styles.file_reset_button}
                onClick={() => props.resetTrienioArquivo(trienioArquivo5Ref)}
                size={22}
              />
            }
          </Col>

          <BriefingThumb
            briefingArquivo={props.trienioArquivo5}
          />
        </Row>
      }

      <Modal show={props.showTrienioModal} onHide={props.handleTrienioModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Erro</Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.trienioError}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.handleTrienioModalClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Trienio;
